<template>
  <div class="colorhead">
    <div class="header">
      <div class="headtle">
        <img :src="logoUrl" alt class="course-img" />
        <span @click="toChannelInfo">{{channelName}}</span>
      </div>
      <div v-if="isShow" class="phone">
        <span v-if="tourist =='false'"  style="margin-right:10px">{{loginName}}</span>
        <span v-if="tourist =='true'"  style="margin-right:10px">游客登录</span>
      | <span @click="toHome" style="margin-left:10px">退出</span>
      </div>
    </div>
    <SwitchMyInfo
      :show="isSwitchMyInfoShow"
      @onChangeProject="onChangeProject"
      @onSubProject="onSubProject"
    ></SwitchMyInfo>

    <SwitchChannelInfo :show="isSwitchChannelInfoShow" @onChannel="onChannel"></SwitchChannelInfo>
  </div>
</template>
<script>
import * as CHANNEL_INFO_API from '@/api/ChannelAPI'
import SwitchMyInfo from '@/components/pc/SwitchMyInfo'
import SwitchChannelInfo from '@/components/pc/SwitchChannelInfo'
export default {
  name: 'Head',
    props: ['isShow'],
  data () {
    return {
      isSwitchMyInfoShow: false,
      isSwitchChannelInfoShow: false,
      channelName: '',
      logoUrl: '',
      loginName: '',
      tourist : localStorage.getItem('tourist')  || sessionStorage.getItem('tourist')
    }
  },
  components: {
    SwitchMyInfo,
    SwitchChannelInfo
  },
  created () {
    if (localStorage.getItem('channelName') != null && localStorage.getItem('logoUrl') != null) {
      this.logoUrl = localStorage.getItem('logoUrl')
      this.channelName = localStorage.getItem('channelName')
    } else {
      this.ChannelFindInfo();
    }
    this.loginName = localStorage.getItem('shangke_username')
  },
  methods: {
    onChangeProject (data) {
      if (data.isSelect) {
        this.isSwitchMyInfoShow = false
      }
    },
    onChannel (data) {
      if (data.isSelect) {
        this.isSwitchChannelInfoShow = false
      }
    },
    // 赋值操作
    onSubProject () {
      this.isSwitchMyInfoShow = false
    },
    ChannelFindInfo () {
      CHANNEL_INFO_API.ChannelFindInfo(null).then(res => {
        this.channelName = res.data.channelName,
          this.logoUrl = res.data.logoUrl
        localStorage.setItem('channelInfo', JSON.stringify(res.data))
        localStorage.setItem('channelName', this.channelName)
        localStorage.setItem('logoUrl', this.logoUrl)
      })
    },
    toHome () {
      this.$router.push({ path: '/pc/login', query: { c_no: sessionStorage.getItem('c_no') || localStorage.getItem('c_no') } })
    },
    // toMyInfo () {
    //   this.isSwitchMyInfoShow = true
    // },
    toChannelInfo () {
      if(localStorage.getItem('isPopupChannelMsg') !=null && localStorage.getItem('isPopupChannelMsg')==1){
        return;
      }
      this.isSwitchChannelInfoShow = true
    }
  }
}
</script>
<style scoped>
.header {
  cursor: pointer;
  display: flex;
  max-width: 1282px;
  height: 80px;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;
}
.headtle img {
  width: 80px;
  height: 80px;
  vertical-align: middle;
}
.headtle span {
  margin-left: 20px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  vertical-align: middle;
}
.phone {
  font-size: 16px;
  font-family: PingFang SC;
}
.colorhead {
  background: rgba(255, 255, 255, 1);
}
</style>